export const getFullAddressTextFromValues = (
  values,
  errors,
  errorClass,
  intl,
  t,
) =>
  t('address:without-name', {
    address: (
      <span className={errors?.address ? errorClass : null}>
        {values.address}
      </span>
    ),
    postalCode: (
      <span className={errors?.postalCode ? errorClass : null}>
        {values.postalCode}
      </span>
    ),
    city: (
      <span className={errors?.city ? errorClass : null}>{values.city}</span>
    ),
    country: (
      <span className={errors?.country ? errorClass : null}>
        {intl.formatDisplayName(values.country, {
          type: 'region',
        })}
      </span>
    ),
  })
